import { useClerk } from "@clerk/react";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccessDenied({ email }) {
  const { signOut } = useClerk();
  return (
    <div className="mesh-dark grain flex min-h-screen items-center justify-center px-4" data-testid="access-denied-screen">
      <div className="w-full max-w-lg rounded-xl border border-border bg-card p-10">
        <div className="flex items-center justify-between">
          <div className="kicker">Mediana Hub · Control de acceso</div>
          <ShieldX className="h-5 w-5 text-bad" strokeWidth={1.75} />
        </div>
        <h1 className="mt-8 font-display text-6xl leading-[0.9] tracking-tight">Acceso denegado</h1>
        <p className="mt-4 text-[15px] leading-relaxed">Mediana Magazine: solo personal interno.</p>
        <p className="mt-2 text-sm text-muted-foreground">
          Esta plataforma solo admite cuentas verificadas con dominio <span className="font-mono text-foreground">@medianamag.com</span>.
          {email && (
            <>
              {" "}La cuenta <span className="font-mono text-foreground" data-testid="denied-email">{email}</span> no tiene permiso.
            </>
          )}
        </p>
        <div className="mt-8 flex items-center gap-3 border-t border-border pt-6">
          <Button onClick={() => signOut({ redirectUrl: "/sign-in" })} data-testid="access-denied-signout-button">
            Volver a iniciar sesión
          </Button>
          <span className="text-xs text-muted-foreground">¿Eres parte del equipo? Escribe a tu Superadmin.</span>
        </div>
      </div>
    </div>
  );
}
